import { render, staticRenderFns } from "./tier-chip.vue?vue&type=template&id=2231e76d"
import script from "./tier-chip.vue?vue&type=script&lang=js"
export * from "./tier-chip.vue?vue&type=script&lang=js"
import style0 from "./tier-chip.vue?vue&type=style&index=0&id=2231e76d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports